

import React, { useEffect, useState, useCallback } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { actionPt, IAction } from '../../utils/action';
import IProject from '../../dtos/IProject';
import { useToast } from '../../hooks/Toast';
import api from '../../services/api';
import { getValidationErrorsMessage } from '../../utils/getValidationErrors';
import * as Yup from 'yup';
import Spinner from '../../components/Spiner';
import { Container, Title, SubTitle, Controle, TdAction, PaginationSpot } from './styles';
import ButtonIcon from '../../components/ButtonIcon';
import Pagination from '../../components/Pagination';
import Table from '../../components/Table';
import Main from '../../components/Main'
import { useAuth } from '../../hooks/Auth';
import IUser from '../../dtos/IUser';
import { format, parseISO } from 'date-fns';



const RegisterProject: React.FC = () => {

    const { credential } = useAuth();
    const { addToast } = useToast();

    const { register: registerFilter, handleSubmit: handleSubmitfilter } = useForm();
    const { register: registerAction, handleSubmit: handleSubmitAction, setValue: setValueAction } = useForm();
    const { handleSubmit: handleSubmitRemove } = useForm();



    const [dataPagination, setdataPagination] = useState<IProject[]>([])

    const [showModalFilter, setShowModalFilter] = useState(false);
    const [showModalAction, setShowModalAction] = useState(false);
    const [showModalRemove, setShowModalRemove] = useState(false);

    const [loading, setLoading] = useState(false)

    const [action, setAction] = useState<IAction>()
    const [projects, setProjects] = useState<IProject[]>([])
    const [project, setProject] = useState<IProject>()


    const [users, setUsers] = useState<IUser[]>()





    useEffect(() => {
        async function Load(): Promise<void> {
            setLoading(true)
            const [responseProject, responseUser] = await Promise.all([
                await api.post('project-filter/', {}),
                await api.post('user-filter/', {})
            ])
            setProjects(responseProject.data);
            setUsers(responseUser.data);
            setLoading(false)

            //para filtro ficar como todos
            setValueAction('user_id', '0')
        }
        Load()
    }, [setValueAction])


    const handleSetForm = useCallback((item: IProject | undefined) => {
        setValueAction('id', item?.id)
        setValueAction('name', item?.name)
        setValueAction('details', item?.details)
        setValueAction('client', item?.client)
        setValueAction('address', item?.address)
        setValueAction('login', item?.login)
        setValueAction('password', item?.password)
        setValueAction('user_id', item?.user?.id)
    }, [setValueAction])



    const handleShowModalFilter = useCallback(() => {
        setShowModalFilter(true)
    }, [])
    const handleHideModalFilter = useCallback(() => {
        setShowModalFilter(false)
    }, [])
    const handleShowModalAction = useCallback(() => {
        setShowModalAction(true)
    }, [])
    const handleHideModalAction = useCallback(() => {
        setShowModalAction(false)
    }, [])
    const handleShowModalRemove = useCallback(() => {
        setShowModalRemove(true)
    }, [])
    const handleHideModalRemove = useCallback(() => {
        setShowModalRemove(false)
    }, [])



    const handleChange = useCallback(
        async (data: IProject) => {

            if (!data || !projects) {
                return
            }
            if (action === 'create') {
                setProjects([...projects, data]);
            }
            if (action === 'update') {
                setProjects(
                    projects.map(item => {
                        if (item.id === data.id) {
                            return data;
                        }
                        return item;
                    }),
                );
            }
            if (action === 'remove') {
                setProjects(projects.filter(item => item.id !== data.id));
            }
        }, [projects, action],
    );


    const handleAction = useCallback((actionHere: IAction, item: IProject | undefined) => {
        handleSetForm(item)
        setProject(item)
        setAction(actionHere)
        if (actionHere === 'remove') {
            handleShowModalRemove()
        } else {
            handleShowModalAction()
        }
    }, [handleShowModalAction, handleShowModalRemove, handleSetForm])


    const handleFilter = useCallback(async (data) => {



        setLoading(true)
        if (data.name_Filter === '') {
            data.name_Filter = undefined;
        }
        if (data.details_Filter === '') {
            data.details_Filter = undefined;
        }
        if (data.client_Filter === '') {
            data.client_Filter = undefined;
        }
        if (data.address_Filter === '') {
            data.address_Filter = undefined;
        }
        if (data.login_Filter === '') {
            data.login_Filter = undefined;
        }
        if (data.password_Filter === '') {
            data.password_Filter = undefined;
        }
        if (data.user_id_Filter === '' || data.user_id_Filter === '0') {
            data.user_id_Filter = undefined;
        }

        const response = await api.post('project-filter/', data)
        setProjects(response.data);
        setLoading(false)

        handleHideModalFilter()

    }, [handleHideModalFilter])


    const handleRemove = useCallback(async () => {
        try {
            const response = await api.delete(`/projects/${project?.id}`);
            addToast({
                type: 'success',
                title: `item ${actionPt(action)}`,
            });

            handleChange(response?.data);
            setProject(undefined)
            handleHideModalRemove()
        } catch (err) {
            addToast({
                type: 'error',
                title: 'Erro no processamento da projeto',
                description: err.response.data.message,
            });

        }
    }, [project, action, addToast, handleChange, handleHideModalRemove])


    const handleModalAction = useCallback(

        async (data) => {

            data.user_id = credential.user.id
            data.created_at = undefined;
            data.updated_at = undefined;


            try {
                const schema = Yup.object().shape({
                    name: Yup.string().required("Nome é obrigatório"),
                    details: Yup.string().required("Detalhes é obrigatório"),
                    client: Yup.string().required("Cliente é obrigatório"),
                    address: Yup.string().required("Endereço é obrigatório"),
                    login: Yup.string().required("Login é obrigatório"),
                    password: Yup.string().required("Senha é obrigatório"),
                    user_id: Yup.string().required("Nome do usuário é obrigatório"),
                });

                await schema.validate(data, {
                    abortEarly: false,
                });
                let response;
                switch (action) {
                    case 'create':
                        response = await api.post('/projects', data);
                        break;
                    case 'update':
                        response = await api.put(`/projects/${project?.id}`, data);
                        break;
                    default:
                        break;
                }

                addToast({
                    type: 'success',
                    title: `item ${actionPt(action)}`,
                });

                handleChange(response?.data);
                handleHideModalAction()
                handleSetForm(undefined)
                setProject(undefined)

            } catch (err) {
                if (err instanceof Yup.ValidationError) {
                    const errors = getValidationErrorsMessage(err);
                    addToast({
                        type: 'error',
                        title: 'Erro no preenchimento do projeto',
                        description: errors,
                    });
                    return;
                }
                addToast({
                    type: 'error',
                    title: 'Erro no processamento do projeto',
                    description: err.response.data.message,
                });
            }
        },
        [addToast, project, handleChange, action, handleHideModalAction, credential, handleSetForm],
    );


    const handleLoadPagination = useCallback((data: any[]) => {
        setdataPagination(data);
    }, [])

    const handleCancelRemove = useCallback(()=>{
        handleHideModalRemove()
    },[handleHideModalRemove])


    return (


        <Main>
            <Container>
                <Title>Cadastro de Projetos</Title>
                <SubTitle>Seque a lista dos projetos cadastrados</SubTitle>
                <Controle>
                    <ButtonIcon iconType="Create" onClick={() => { handleAction('create', undefined) }} />
                    <ButtonIcon iconType="Filter" onClick={handleShowModalFilter} />
                </Controle>

                <Table >
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nome</th>
                            <th>Detalhes</th>
                            <th>Cliente</th>
                            <th>Endereço</th>
                            <th>Login</th>
                            <th>Senha</th>
                            <th>Criação</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataPagination.map(item => (
                            < tr key={item.id}>
                                <td>{item.id} </td>
                                <td>{item.name} </td>
                                <td>{item.details} </td>
                                <td>{item.client} </td>
                                <td> <a href={item.address} target='blank'>{item.address}</a> </td>
                                <td>{item.login} </td>
                                <td>{item.password} </td>
                                <td>{`${format(parseISO(String(item.updated_at)), 'dd/MM/yy')} - `}<strong> {item.user.name} </strong>   </td>
                                <TdAction>
                                    <ButtonIcon
                                        iconType="Update"
                                        onClick={() => { handleAction('update', item) }}
                                        title={credential.permissions === 'admin' ? 'Atualizar' : 'Você não tem permissão para era essa ação'}
                                        disabled={credential.permissions === 'admin' ? false : true}
                                    />
                                    <ButtonIcon
                                        iconType="Remove"
                                        onClick={() => { handleAction('remove', item) }}
                                        title={credential.permissions === 'admin' ? 'Remover' : 'Você não tem permissão para era essa ação'}
                                        disabled={credential.permissions === 'admin' ? false : true}
                                    />
                                </TdAction>
                            </tr>
                        ))}

                    </tbody>
                </Table>

                {loading && (<Spinner />)}


                <Modal size="lg" show={showModalFilter} onHide={handleHideModalFilter} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Selecione os filtros</Modal.Title>
                    </Modal.Header  >
                    <Modal.Body >
                        <Form onSubmit={handleSubmitfilter(handleFilter)}>
                            <Form.Group>
                                <Form.Label className="text-muted small"> Nome</Form.Label>
                                <Form.Control  {...registerFilter("name_Filter")} type="text" placeholder="Entre com o nome" />
                            </Form.Group>
                            <Form.Group >
                                <Form.Label className="text-muted small">Detalhes</Form.Label>
                                <Form.Control {...registerFilter("details_Filter")} type="text" placeholder="Entre com o detalhes" />
                            </Form.Group>
                            <Form.Group >
                                <Form.Label className="text-muted small">Cliente</Form.Label>
                                <Form.Control {...registerFilter("client_Filter")} type="text" placeholder="Entre com o cliente" />
                            </Form.Group>
                            <Form.Group >
                                <Form.Label className="text-muted small">Endereço</Form.Label>
                                <Form.Control {...registerFilter("address_Filter")} type="text" placeholder="Entre com o endereço" />
                            </Form.Group>
                            <Form.Group >
                                <Form.Label className="text-muted small">Login</Form.Label>
                                <Form.Control {...registerFilter("login_Filter")} type="text" placeholder="Entre com o login" />
                            </Form.Group>
                            <Form.Group >
                                <Form.Label className="text-muted small">Senha</Form.Label>
                                <Form.Control {...registerFilter("password_Filter")} type="text" placeholder="Entre com a senha" />
                            </Form.Group>
                            <Form.Group >
                                <Form.Label className="text-muted small">Usuário</Form.Label>
                                <Form.Control  {...registerFilter("user_id_Filter")} as="select" aria-label="Default select example">
                                    <option key={'0'} value={'0'} >Todos</option>
                                    {users?.map(item => (
                                        <option key={item.id} value={item.id}>{item.name}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                            <Button variant="success" type="submit" className="btn mb-4">Filtar</Button>
                        </Form>
                    </Modal.Body>
                </Modal>



                <Modal size="lg" show={showModalRemove} onHide={handleHideModalRemove} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirme a exclusão do registro</Modal.Title>
                    </Modal.Header  >
                    <Modal.Body >
                        <Form onSubmit={handleSubmitRemove(handleRemove)}>
                            <Form.Row>
                                <Form.Group className="mr-2" >
                                    <Button variant="success" type="submit" className="btn mb-4">Confirmar</Button>
                                </Form.Group>
                                <Form.Group  >
                                    <Button variant="dark" onClick={handleCancelRemove} className="btn mb-4">Cancelar</Button>
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    </Modal.Body>
                </Modal>



                <Modal size="lg" show={showModalAction} onHide={handleHideModalAction} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>{action === 'create' ? "Adicionar Registro" : "Atualizar Registro"}</Modal.Title>
                    </Modal.Header  >
                    <Modal.Body >
                        <Form onSubmit={handleSubmitAction(handleModalAction)}>
                            <Form.Group>
                                <Form.Label className="text-muted small"> Id</Form.Label>
                                <Form.Control disabled  {...registerAction("id")} type="number" />
                            </Form.Group>
                            <Form.Group >
                                <Form.Label className="text-muted small">Nome</Form.Label>
                                <Form.Control {...registerAction("name")} type="text" placeholder="Entre com o nome do projeto" />
                            </Form.Group>
                            <Form.Group >
                                <Form.Label className="text-muted small">Detalhes</Form.Label>
                                <Form.Control  {...registerAction("details")} type="text" placeholder="Entre com os detalhes" />
                            </Form.Group>
                            <Form.Group >
                                <Form.Label className="text-muted small">Cliente</Form.Label>
                                <Form.Control  {...registerAction("client")} type="text" placeholder="Entre com o cliente" />
                            </Form.Group>
                            <Form.Group >
                                <Form.Label className="text-muted small">Endereço</Form.Label>
                                <Form.Control {...registerAction("address")} type="text" placeholder="Entre com o endereço" />
                            </Form.Group>
                            <Form.Group >
                                <Form.Label className="text-muted small">Login</Form.Label>
                                <Form.Control {...registerAction("login")} type="text" placeholder="Entre com o login" />
                            </Form.Group>
                            <Form.Group >
                                <Form.Label className="text-muted small">Senha</Form.Label>
                                <Form.Control  {...registerAction("password")} type="text" placeholder="Entre com a senha" />
                            </Form.Group>

                            <Button variant="success" type="submit" className="btn mb-4">Salvar</Button>
                        </Form>
                    </Modal.Body>
                </Modal>




                <PaginationSpot>
                    <Pagination data={projects} handleLoadPagination={handleLoadPagination} />
                </PaginationSpot>


            </Container>
        </Main >




    );
};


export default RegisterProject;